import { createApi } from "@reduxjs/toolkit/query/react";

import type { TGetMyPermissionsResponse } from "@/types/(company)/roles.interface";
import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";
import { MS_MY_PERMISSIONS } from "@/constants/apiEndpoints";

// Fetches the CURRENT user's own permission matrix. This is the bootstrap for
// usePermissions() and MUST hit a self-scoped, non-permission-gated endpoint —
// fetching a role via `/employee/roles/:id` requires `settings:canView`, which
// ordinary employees don't have, so it 403s and leaves them with no permissions.
export const myPermissionsApi = createApi({
  reducerPath: "myPermissionsApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["getMyPermissions"],
  endpoints: (builder) => ({
    getMyPermissions: builder.query<TGetMyPermissionsResponse, void>({
      query: () => ({
        url: MS_MY_PERMISSIONS,
        method: "GET",
      }),
      providesTags: ["getMyPermissions"],
    }),
  }),
});

export const { useGetMyPermissionsQuery } = myPermissionsApi;
